import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const I18N_VALUES = {
  it: {
    weekdays: ['Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa', 'Do'],
    months: [
      'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
      'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
    ]
  }
};

@Injectable({
  providedIn: 'root'
})
export class ItalianDatepickerI18nService extends NgbDatepickerI18n {
  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES.it.weekdays[weekday - 1];
  }

  getMonthShortName(month: number): string {
    return I18N_VALUES.it.months[month - 1].substring(0, 3);
  }

  getMonthFullName(month: number): string {
    return I18N_VALUES.it.months[month - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }

  getWeekdayLabel(weekday: number, width?: 'long' | 'short' | 'narrow'): string {
    // Return the full name for 'long', short name for 'short' or 'narrow'
    if (width === 'long') {
      // You can provide full names if needed, here using short names as placeholder
      // Replace with full names if available
      return I18N_VALUES.it.weekdays[weekday - 1];
    }
    return I18N_VALUES.it.weekdays[weekday - 1];
  }
}